var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"profile-header mb-2",attrs:{"img-src":require('@/assets/images/header/bf.jpg'),"img-top":"","alt":"cover photo","body-class":"p-0"}})}
var staticRenderFns = []

export { render, staticRenderFns }